import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { FetchXMLTemplateModel, FetchXMLTemplateRequest } from '../model/Engagement/FetchXMLTemplateModel';
import { Observable } from "rxjs";
import { AppConfigService } from './appConfigService';

 @Injectable()
 export class FetchXMLTemplateService {
    APIEndPoint: string;

    constructor(private enviornment: AppConfigService, private http: HttpClient) {
        this.APIEndPoint = this.enviornment.config.DATA.API_END_POINT.API_URL;
      }

    getFetchXmlTemplatesByTemplateName(fetchXMLtemplateRequest: FetchXMLTemplateRequest): Observable<FetchXMLTemplateModel[]> {
        return this.http.post<FetchXMLTemplateModel[]>(`${this.APIEndPoint}/fetch-xml-templates/search`,fetchXMLtemplateRequest);
      }
 }